<template>
<!-- 评论管理 -->
<section class="comment">
  <div class="tittle">
    <!-- <p class="spanflex">
      <span @click="clickspan1()" :class="span1_show ==1 ?'red':'nored'"
        style="margin-left:5px;display:inline-block;height:30px;cursor:pointer;margin-left:30px; position: relative;">
        对商家的评论
        <span v-show="span1_show ==1" class="redspan"></span>
      </span>
      <span @click="clickspan2()" :class="span1_show ==2 ?'red':'nored'"
        style="margin-left:25px;display:inline-block;height:30px;cursor:pointer; position: relative; ">
        对商品的评论
        <span v-show="span1_show ==2" class="redspan"></span>
      </span>
      <span @click="clickspan3()" :class="span1_show ==3 ?'red':'nored'"
        style="margin-left:25px;display:inline-block;height:30px;cursor:pointer; position: relative; ">
        对订单的评论
        <span v-show="span1_show ==3" class="redspan"></span>
      </span>
    </p> -->
    <!-- <span class="wei" v-show="span1_show"></span>
    <span class="yi"  v-show="span2_show"></span>-->
  </div>
  <!--工具条-->
  <shopcomment v-show="span1_show == 1"></shopcomment>
  <goodscomment v-show="span1_show == 2"></goodscomment>
  <div v-show="span1_show == 3">
    <div v-show="isComment">
      <el-col :span="24" class="toolbar pad_left">
        <div class="main_container">
          <div class="fuji" @click="show3 = !show3">
            <p style="margin: 0;margin-left: -22px;" class="goodslist1">
              <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
              <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
            </p>
            <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"/>
          </div>
          <!-- 顶部搜索框 -->
          <el-collapse-transition>
            <div style="padding:0px 12px" v-show="show3">
            <el-form class="findform" :inline="true" style="margin-top:20px;display:flex">
              <el-form-item style="width:32.5%;display:flex" label="商品编码：">
                <el-input v-model="commodityCode" placeholder="请输入关键词"></el-input>
              </el-form-item>
              <el-form-item label="商品活动类型：" style="width:32.5%;display:flex" class="select">
                <el-select v-model="saleType" placeholder="请选择" style="background:#fff" ref="mySelect">
                  <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in xiaoshouoptions" :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="button" class="search_btn" @click="chanxun" cla>查询</el-button>
              </el-form-item>
            </el-form>
            </div>
          </el-collapse-transition>
        </div>
      </el-col>

      <!--列表-->
      <template>
        <el-col
          :span="24"
          style="margin-top:10px;margin-bottom:10px"
          class="main_container pad_left"
        >
          <section class="model_section" style="border-bottom:none">
            <el-col :span="18" style>
              <p class="model_top_title">评论管理</p>
            </el-col>
          </section>
          <div class="table_container">
            <div class="table_inner_container">
              <el-table :data="users" class="ban_tab" stripe border style="height:auto">
                <el-table-column label="序号" width="64" align="center">
                  <template slot-scope="scope">
                    <span>{{scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="GoodModelCode" label="产品型号" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.GoodModelCode"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.GoodModelCode}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="BrandTypeName" label="品类" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.BrandTypeName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandTypeName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="BrandName" label="品牌" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.BrandName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.BrandName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="SaleType" label="销售方式" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.SaleType"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.SaleType}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="PurchaseCount" label="购买数量" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.PurchaseCount"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.PurchaseCount}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ReviewCount" label="评论数量" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.ReviewCount"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ReviewCount}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="NewReviewDate" label="最新评论时间" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.NewReviewDate"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.NewReviewDate}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="280" align="center">
                  <div class="comment_edit action_container" slot-scope="scope">
                    <p @click="showAdd(scope.row)" v-if="menuAction.indexOf(65)>-1">
                      <i class="el-icon-edit-outline"></i> 编辑
                    </p>
                  </div>
                </el-table-column>
              </el-table>
              <el-col :span="24" style="margin-top:10px" class="toolbar_footer">
                <el-pagination
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                  :page-size="10"
                  :current-page="pageIndex"
                  :total="total"
                  style="float:right;"
                ></el-pagination>
              </el-col>
            </div>
          </div>
        </el-col>
      </template>
    </div>
  </div>
  <!--编辑界面-->
  <el-col :span="24" class="add_comment pad_left main_container" v-show="isAdd">
    <section class="model_section">
      <p class="model_top_title">评论管理编辑</p>
      <el-button type="danger" @click="closeisAdd()" style="float: right;margin: 5px 10px 0 0;">返 回</el-button>
    </section>
    <div class="sale_evalute" v-show="ispinglun">
      <div class="sale_eva_main">
        <!-- 评价 -->
        <div class="sale_eva_title">
          <!-- 标题 -->
          <h3>
            <p></p>评价
          </h3>
          <!-- 星 -->
          <p>***************************************************************************************************************************************************************************************************************************************************************</p>
        </div>
        <!-- 全部评价 -->
        <div class="sale_eva_all">
          <!-- 好评度 -->
          <div class="sale_eva_degree">
            <div>
              <span>好评度</span>
              <span>
                <p>{{AvgScore}}</p>
                <p>%</p>
              </span>
            </div>
          </div>
          <!-- 评价选项 -->
          <div class="sale_eva_option">
            <p
              v-for="(item,index) in saleList"
              :key="index"
              :class="{sale_color:isColor == index}"
              @click="changeColor(index)"
            >{{item.KeyWord}}</p>
          </div>
        </div>
        <!-- 评价详情导航栏 -->
        <div class="sale_eva_detail">
          <!-- 导航栏 -->
          <!-- @click="changeNavColor(item.index)" -->
          <div class="sale_det_nav">
            <p
              v-for="(item,index) in saleNavList"
              :key="item.index"
              :class="{color:navColor == index}"
              @click="changeping(item,index)"
            >{{item.Name}}({{item.Counts}})</p>
          </div>
          <!-- 详情 -->
          <div style="margin-bottom:10px" class="sale_det_concrete">
            <div class="sale_concrete_top" v-for="(item,index) in commentlist" :key="index">
              <div class="sale_concrete_l">
                <span class="photo_img_box">
                  <img :src="item.ReviewImgs" alt />
                </span>
                <span style="margin-top:-75px">
                  <p>{{item.UserName}}</p>
                </span>
              </div>
              <!-- 评价内容 -->
              <div class="sale_concrete_r">
                <!-- 评分 -->
                <el-rate
                  v-model="item.GoodSatisfaction"
                  :colors="['#F56C6C', '#F56C6C', '#F56C6C']"
                  :disabled="true"
                ></el-rate>
                <!-- 评价文字 -->
                <p class="commentText" v-html="item.RContent"></p>
                <!-- <div v-for="(item,index) in item.ReviewImg" :key="index">
                  <img :src="item.ImgUrl" alt />
                </div>-->
                <div>
                  <img
                    style="width:100px;height:100px;margin-right:10px"
                    :data-img="url.ImgUrl"
                    @click="$imgPreview"
                    v-for="(url,i) in item.ReviewImgs"
                    :src="url.ImgUrl"
                    :key="i"
                    alt
                  />
                </div>
                <!-- 评价时间 -->
                <span>{{item.CTime}}</span>
                <div class="conmment_delete addressfind" v-show="userType == 5||BbId == 1" @click="del(item.Id,1)">删除</div>
                <div v-show="item.ReplyModel.length ==0?true:false" style="background:#fff;color:#F56C6C;border:1px solid #F56C6C" class="conmment_delete1 addressfind" @click="volume(item.Id)">回复</div>
              </div>
              <div v-show="item.ReplyModel.length ==0?false:true" style="display:flex;justify-content: space-between;">
                <div style="margin-left: 169px;">
                  <p  style="color:#ef3f3f">{{item.ReplyModel.length ==0?"":item.ReplyModel[0].UserName}} 回复：</p>
                  <p style="color:#ef3f3f;word-break: break-word;">{{item.ReplyModel.length ==0?"":item.ReplyModel[0].RContent}}</p>
                  <p>{{item.ReplyModel.length ==0?"":item.ReplyModel[0].CTime}}</p>
                </div>
                <div>
                  <span
                  v-show="userType == 5||userType == 4||BbId == 1"
                    style=" width: 60px;cursor: pointer;height:30px;margin-right:28px; display:inline-block;line-height:30px;text-align:center;border-radius:3px;margin-top:29px;background:#fff;color:#F56C6C;border:1px solid #F56C6C"
                    class="addressfind"
                    @click="del(item.ReplyModel[0].Id,2)"
                  >删除</span>
                </div>
              </div>
                  <div style="height:1px;width:100%;background:#eee;margin-left:169px;margin-bottom:25px"></div>
            </div>
            <!-- 晒图评价 -->
            <!-- <div class="sale_concrete_top">
            <div class="sale_concrete_l">
              <span>
                <img src="../../assets/img/bicon26.png" alt />
                <p>甄惠装粉丝~</p>
              </span>
            </div>
            
            <div class="sale_concrete_r">
              
              <el-rate
                v-model="value"
                :colors="['#F56C6C', '#F56C6C', '#F56C6C']"
                :disabled="true"
              ></el-rate>
              
              <p>原来家里就买了一个，那会觉得就挺好看的，样子简单大方，上档次，用了一年效果也不错，朋友来家里都夸好看也好用这次给朋友家里也买了一个，价格还是那么实惠，安装师傅也来的很快，装上这，卫生间都变得好看了好多，很满意的一次购物。</p>
              
              <div>
                <img src="../../assets/img/bicon28.png" alt />
              </div>
              
              <i>2019-04-09</i>
              <div class="conmment_delete">删除</div>
            </div>
            </div>-->
          
        
          
          </div>
          
        </div>
      </div>

      <el-col
        :span="24"
        class="toolbar_footer"
        v-if="commentlist.length!=0"
        style="border-bottom:none"
      >
        <el-pagination
          layout="prev, pager, next"
          @current-change="pinglunCurrentChange"
          :page-size="10"
          :current-page="pageIndex"
          :total="pingtotal"
          style="float:right;margin-bottom:15px"
        ></el-pagination>
      </el-col>
    </div>
  </el-col>
  <!-- 删除弹窗 -->
  <section class="bill_delete">
    <el-dialog class="add_bill_delete" width="622px" title="删除" :visible.sync="deleteFormVisble">
      <div>
        <div class="delete_tips">
          <p>重要信息，你确定要删除吗？</p>
        </div>
        <div class="delete_footer">
          <p @click="shan()">确定</p>
          <p @click="deleteFormVisble = false">取消</p>
        </div>
      </div>
    </el-dialog>
  </section>
</section>
</template>
<script>
import goodscomment from "./goodscomment.vue";
import shopcomment from "./shopcomment.vue";
import { pinglun, getkind, productPinglun, guanjianzi, deletepinglun, InsertReviewReply,} from "../../api/api";
// 评价
import saleEvalute from "./saleEvalute.vue";
// 常见问题
import saleCommonProblem from "./saleCommonProblem.vue";
// 预约咨询
import saleSubscribe from "./saleSubscribe.vue";
export default {
  components: {
    saleEvalute
  },
  data() {
    return {
      show3: true, // 查询区域默认展开
      userType:'',
      BbId:'',
      ReplyModel:{},
      span1_show: 1,
      imgarr: [],
      deleteFormVisble: false,
      goodsId: "",
      // 详情显示
      showInfor: false,
      // 评价显示
      showEvalute: true,
      // 常见问题显示
      showCommon: false,
      // 预约咨询显示
      showSub: false,
      commodityCode: "", // 商品编码
      saleType: "", // 商品活动类型
      users: [],
      total: 1,
      page: 1,
      form: {
        id: 0,
        theme: "",
        link: "",
        options: "",
        option2: ""
      },
      tempindex: "",
      // comment是否显示
      isComment: true,
      // 新增页面
      isAdd: false,
      list: [
        { index: 1, name: "详情" },
        { index: 2, name: "评价 (12456)" },
        { index: 3, name: "常见问题" },
        { index: 4, name: "预约咨询" }
      ],
      isBorder: 2,
      pageIndex: 1,
      pageSize: 10,
      xiaoshouoptions: [],
      copageIndex: 1,
      copageSize: 10,
      // 评价
      value: 3,
      // 评价选项颜色
      isColor: -1,
      AvgScore: "",
      saleList: [],
      // 评价详情导航栏
      navColor: -1,
      saleNavList: [
        { index: 1, Name: "全部评价", Counts: "0" },
        { index: 2, Name: "好评", Counts: "0" },
        { index: 3, Name: "晒图", Counts: "0" },
        { index: 4, Name: "差评", Counts: "0" }
      ],
      pingtotal: 1,
      pingpageIndex: 1,
      pingpageSize: 10,
      keyList: [],
      ispinglun: false,
      commentlist: "",
      delid: "",
      pingkeyword: "",
      survey: "",
      deltype:1,
      
    };
  },
  methods: {
    // 重置
    fnReset() {
      this.commodityCode = ""; // 商品编码
      this.saleType = ""; // 商品活动类型
    },
    // 回复
    volume(val) {
      this.$swal({
        title: "商家回复",
        text: "在下方输入框内输入商家回复",
        input: "textarea",
        inputPlaceholder: "请输入商家回复",
        inputValue: "",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(inputVal => {
         if(inputVal.value==""){
           this.$swal({
              text: "请输入商家回复",
              type:"warning"
           })
         }else if(inputVal.value.length>500){
          this.$swal({
              text: "最多输入500字",
              type:"warning"
           })
         }else{
           var obj = {
             userId:localStorage.Id,
             reviewId:val,
             rContent:inputVal.value
           }
           InsertReviewReply(obj).then(data=>{
             if(data.ResultCode == 1){
               this.$swal({
                 type:"success",
                 text:"操作成功"
               })
               this.getgoodcomment()
             }
           })
         }
      });
    },
    clickspan1() {
      this.span1_show = 1;
      this.isAdd = false;
    },
    clickspan2() {
      this.span1_show = 2;
      this.isAdd = false;
    },
    clickspan3() {
      this.span1_show = 3;
      this.isAdd = false;
    },
    //获取销售类型
    getxiaoshoutype() {
      let that = this;
      var loginParams = {
        tableName: "tbdgoodsactive",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        let tempData = data.ResultObj;
        tempData.unshift({
          Id: 0,
          Name: "全部"
        });
        that.xiaoshouoptions = tempData;
        that.saleType = tempData[0].Id;
        that.getcommentlist();
      })
    },
    showAdd(scope) {
      let that = this;
      this.goodsId = scope.Id;
      this.isComment = false;
      this.isAdd = true;
      this.ispinglun = true;
      // that.getgoodcomment();
      that.getkeyword();
    },
    closeisAdd() {
      this.isComment = true;
      this.isAdd = false;
      this.ispinglun = false;
    },
    showBan() {
      this.isComment = true;
      this.isAdd = false;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getcommentlist();
    },

    //评论分页
    pinglunCurrentChange(val) {
      this.pingpageIndex = val;
      this.getgoodcomment();
    },
    // 显示下划线
    changeBorder(index) {
      this.isBorder = index;
      if (index == 1) {
        this.toInfor();
      }
      if (index == 2) {
        this.toEvalute();
      }
      if (index == 3) {
        this.toCommon();
      }
      if (index == 4) {
        this.toSub();
      }
    },
    // 显示详情
    toInfor() {
      (this.showInfor = true),
        (this.showEvalute = false),
        (this.showCommon = false);
      this.showSub = false;
    },
    // 显示评价
    toEvalute() {
      (this.showInfor = false), (this.showEvalute = true);
      this.showCommon = false;
      this.showSub = false;
    },
    // 显示常见问题
    toCommon() {
      this.showEvalute = false;
      this.showInfor = false;
      this.showCommon = true;
      this.showSub = false;
    },
    // 显示预约咨询
    toSub() {
      this.showEvalute = false;
      this.showInfor = false;
      this.showCommon = false;
      this.showSub = true;
    },

    changeColor(index) {
      this.survey = "";

      if (index == this.isColor) {
        this.pingkeyword = "";
        this.isColor = -1;
      } else {
        this.isColor = index;
        let newsaleList = this.saleList;
        this.commentlist = [];
        for (var i = 0; i < newsaleList.length; i++) {
          if (i == index) {
            this.pingkeyword = newsaleList[i].KeyWord;
          }
        }
      }
      this.getgoodcomment();
    },
    // 评价选择
    changeping(item,index) {
      this.isColor = -1
      this.pingkeyword = "";
      if (index == this.navColor) {
        // this.survey = "";
        // this.navColor = -1;
      } else {
        this.navColor = index;
        let newsaleNavList = this.saleNavList;
        this.commentlist = [];
        for (var i = 0; i < newsaleNavList.length; i++) {
          if (i == index) {
            this.survey = newsaleNavList[i].Id;
          }
        }
        this.getgoodcomment();
      }
    },
    changeNavColor(index) {
      this.navColor = index;
    },
    chanxun() {
      this.pageIndex = 1;
      this.getcommentlist();
    },
    //获取评论列表
    getcommentlist() {
      var addParams = {
        userId: localStorage.Id,
        key: this.commodityCode, // 商品编码
        saleType: this.saleType, // 商品活动类型
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      pinglun(addParams)
        .then(data => {
          this.total = data.RowsCount;
          this.users = data.ResultObj;
        })
        .catch(err => {
          this.orderlist = [];
        });
    },
    //查询商品评论
    getgoodcomment() {
      let that = this;
      var addParams = {
        keyWord: that.pingkeyword,
        goodsId: that.goodsId,
        pageIndex: that.pingpageIndex,
        pageSize: that.pingpageSize,
        survey: that.survey
      };
      productPinglun(addParams)
        .then(data => {
          if (data.ResultCode == 1) {
            that.pingtotal = data.RowsCount;
            that.commentlist = data.ResultObj.GoodsReview_Front_Models;
            that.AvgScore = data.ResultObj.GoodsReview_Statis_Model.AvgScore;
            let newSurveys = data.ResultObj.GoodsReview_Surveys;
            let totalcount = 0;
            for (var i = 0; i < newSurveys.length; i++) {
              totalcount = totalcount + Number(newSurveys[i].Counts);
            }
            var obj = {
              Id: 0,
              Counts: data.ResultMsg,
              Name: "全部评价"
            };
            newSurveys.unshift(obj);
            that.saleNavList = newSurveys;
            // this.users = data.ResultObj;
          } else if (data.ResultCode == 4 && that.survey == "") {
            this.saleNavList = [
              { index: 1, Name: "全部评价", Counts: "0" },
              { index: 2, Name: "好评", Counts: "0" },
              { index: 3, Name: "差评", Counts: "0" },
              { index: 4, Name: "有图", Counts: "0" }
            ];
            this.commentlist = [];
          }
        })
        .catch(err => {
          that.commentlist = [];
        });
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    // 获取关键字统计
    getkeyword() {
      let that = this;
      var addParams = {
        goodsId: that.goodsId
      };
      guanjianzi(addParams).then(data => {
        data = data.ResultObj;
        that.saleList = data;
        this.getgoodcomment();
      })
    },
    //删除商品评论
    del(id,val) {
      let that = this;
      this.deltype = val
      this.delid = id;
      // this.deleteFormVisble = true;
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.shan();
        }
      });
    },
    shan() {
      let that = this;
      var addParams = {
        userId:localStorage.Id,
        id: that.delid,
        type: this.deltype
      };
      deletepinglun(addParams).then(data => {
        if (data.ResultCode == 1) {
          that.getkeyword();
          that.getgoodcomment();
          this.$swal({
            type: "success",
            text: "删除成功"
          });
        }
        this.deleteFormVisble = false;
      });
    }
  },
  components: {
    saleEvalute,
    saleCommonProblem,
    saleSubscribe,
    shopcomment,
    goodscomment
  },

  mounted() {
    this.getxiaoshoutype();
    this.userType = localStorage.UserType;
    this.BbId = localStorage.BbId;
    // this.getkeyword();
    //获取问答管理
    // this.getUsers();
    this.span1_show = 3;
    this.isAdd = false;
  },
  props: ["menuAction"],
  watch: {
    menuAction: function(val) {
      this.menuAction = val;
    }
  }
};
</script>

<style scoped>
.red {
  margin-right: 8%;
  width: 130px;
  height: 100px;
  color: #F56C6C;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 600;
}
.redspan {
  background: #F56C6C;
  width: 130px;
  height: 2px;
  display: block;
  position: absolute;
  top: 40px;
  left: 0;
}
.nored {
  margin-right: 8%;
  width: 130px;
  height: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 500;
}
.spanflex {
  display: flex;
}
.special_border {
  border-bottom: 2px solid rgba(222, 7, 22, 1);
  color: #F56C6C;
  font-weight: bold;
}
.comment .toolbar {
  height: auto;
}

/* 评论管理 */
/* 内容表格 */
.comment_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  height: 640px;
  position: relative;
}
/* 标题 */
.comment_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
/* 评论管理 */
.comment_table .el-col-22 p {
  width: 80px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.comment_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.ban_tab .comment_edit {
  float: left;
  color: #677c9d;
  width: 30%;
  margin-left: 35%;
  color: #677c9d;
  cursor: pointer;
}

/* 编辑页面 */
.add_comment {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  overflow: hidden;
  zoom: 1;
  position: relative;
}
.add_comment .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

/* 选项 */
.add_comment .commont_option {
  width: 80%;
  height: 46px;
  border: 1px solid rgba(237, 237, 237, 1);
  border-bottom: 2px solid rgba(0, 0, 0, 1);
  color: rgba(85, 85, 85, 1);
  margin: 20px 0 0 20px;
}
/* 具体选项 */
.add_comment .commont_option p {
  width: 120px;
  height: 46px;
  border-right: 1px solid rgba(237, 237, 237, 1);
  line-height: 46px;
  text-align: center;
  float: left;
  font-size: 16px;
  cursor: pointer;
  margin: 0;
}
</style>
<style>
.sale_evalute {
  /* width: 1200px; */
  background: #fff;
  margin-left: 20px;
}
.sale_eva_main {
  /* width: 1200px; */
  margin: 0 auto;
}
/* 评价 */
.sale_eva_main .sale_eva_title {
  /* height: 410px; */
  margin-top: 25px;
}
/* 评价标题 */
.sale_eva_title h3 {
  color: #333;
  text-align: left;
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: normal;
}
.sale_eva_title h3 p {
  display: inline-block;
  width: 4px;
  height: 21px;
  background: rgba(222, 7, 22, 1);
  margin: 0 10px -4px 0;
}
/* 星 */
.sale_eva_title p {
  color: rgba(237, 237, 237, 1);
  margin: 0;
}
/* 全部评价 */
.sale_eva_all {
  height: 144px;
}
/* 好评度 */
.sale_eva_all .sale_eva_degree {
  float: left;
  width: 85px;
  height: 80px;
  text-align: left;
  margin: 15px 0 0 15px;
}
/*  */
.sale_eva_degree span {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
  margin-bottom: 10px;
}
/* 百分比 */
.sale_eva_degree span p {
  color: rgba(222, 7, 22, 1);
  font-size: 14px;
  float: left;
  line-height: 28px;
  margin: 0;
}
.sale_eva_degree span p:first-child {
  font-size: 28px;
}
/* 评价选项卡 */
.sale_eva_all .sale_eva_option {
  width: 1050px;
  height: 80px;
  font-size: 14px;

  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  margin-top: 30px;
}
/* 文字 */
.sale_eva_all .sale_eva_option p {
  width: 114px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
  border: 1px solid rgba(237, 237, 237, 1);
  margin: 0 10px 10px 0;
  cursor: pointer;
}
/* 评价详情 */
/* 导航栏 */
.sale_eva_main .sale_eva_detail .sale_det_nav {
  /* width: 1200px; */
  height: 46px;
  background: rgba(248, 248, 248, 1);
  margin-bottom: 22px;
  line-height: 46px;
}
.sale_eva_detail .sale_det_nav p {
  float: left;
  margin: 0 35px 0 16px;
  color: rgba(85, 85, 85, 1);
  font-size: 12px;
  cursor: pointer;
}
/* 评价选项颜色 */
.sale_color {
  border-color: rgba(222, 7, 22, 1) !important;
  color: rgba(222, 7, 22, 1) !important;
}
/* 评价详情导航栏颜色 */
.color {
  color: rgba(222, 7, 22, 1) !important;
}
/* 评价详情 */
.sale_eva_main .sale_eva_detail .sale_det_concrete .sale_concrete_top {
  overflow: hidden;
  margin-bottom: 20px;
}
/* 左侧评价人 */
.sale_det_concrete .sale_concrete_l {
  width: 170px;
  height: 116px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  float: left;
}
.el-rate__icon {
  margin-right: 0 !important;
}
/* 头像 */
.sale_concrete_l span img {
  float: left;
}
/* 甄惠装粉丝 */
.sale_concrete_l span p {
  float: left;
  font-size: 14px;
  color: rgba(136, 136, 136, 1);
  margin: 0 0 0 10px;
}
/* 右侧评价内容 */
.sale_det_concrete .sale_concrete_r {
  padding-right: 20px;
  margin-left: 170px;
  text-align: left;
  position: relative;
  width: auto;
  box-sizing: border-box;
  padding: 10px 0 15px;
}
/* 删除按钮 */
.conmment_delete {
  position: absolute;
  top: 0;
  right: 27px;
  width: 60px;
  height: 30px;
  background-color: #6786b4;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.conmment_delete1 {
  position: absolute;
  top: 61px;
  right: 27px;
  width: 60px;
  height: 30px;
  background-color: #6786b4;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
/* 评分 */
/* 评价文字 */
.sale_concrete_r p {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 23px;
}
/* 评价时间 */
.sale_concrete_r i {
  display: inline-block;
  font-size: 22px;
  color: rgba(136, 136, 136, 1);
  /* margin: 34px 0; */
}
.star {
  font-size: 16px;
}
.photo_img_box {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}
.photo_img_box img {
  width: 100%;
}
.commentText {
  width: 90%;
  word-break:break-all;
}
</style>




// WEBPACK FOOTER //
// comment.vue?19f75180